/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
import DetailsPanel from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel';

@translate()
export default class AssetExtensionRequest extends React.Component<*> {
  render(): React.Element<*> {
    return (
      <React.Fragment>
        <DetailsPanel data={this.props.data} />
      </React.Fragment>
    );
  }
}
